import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Créer une instance axios avec configuration de base
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs d'authentification
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ==================== AUTHENTIFICATION ====================
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (data) => api.post('/auth/register', data),
};

// ==================== CLIENTS ====================
export const clientsAPI = {
  getAll: () => api.get('/clients'),
  getById: (id) => api.get(`/clients/${id}`),
  create: (data) => api.post('/clients', data),
  update: (id, data) => api.put(`/clients/${id}`, data),
  delete: (id) => api.delete(`/clients/${id}`),
};

// ==================== ANIMAUX ====================
export const animauxAPI = {
  getAll: () => api.get('/animaux'),
  getById: (id) => api.get(`/animaux/${id}`),
  create: (data) => api.post('/animaux', data),
  update: (id, data) => api.put(`/animaux/${id}`, data),
  delete: (id) => api.delete(`/animaux/${id}`),
};

// ==================== CONSULTATIONS ====================
export const consultationsAPI = {
  getAll: () => api.get('/consultations'),
  getById: (id) => api.get(`/consultations/${id}`),
  create: (data) => api.post('/consultations', data),
  update: (id, data) => api.put(`/consultations/${id}`, data),
  delete: (id) => api.delete(`/consultations/${id}`),
};

// ==================== MÉDICAMENTS ====================
export const medicamentsAPI = {
  getAll: () => api.get('/medicaments'),
  getById: (id) => api.get(`/medicaments/${id}`),
  create: (data) => api.post('/medicaments', data),
  update: (id, data) => api.put(`/medicaments/${id}`, data),
  delete: (id) => api.delete(`/medicaments/${id}`),
};

// ==================== DETTES ====================
export const dettesAPI = {
  getAll: () => api.get('/dettes'),
  getById: (id) => api.get(`/dettes/${id}`),
  create: (data) => api.post('/dettes', data),
  update: (id, data) => api.put(`/dettes/${id}`, data),
  delete: (id) => api.delete(`/dettes/${id}`),
};
// ==================== PAIEMENTS ====================
export const paiementsAPI = {
  getAll: () => api.get('/paiements'),
  create: (data) => api.post('/paiements', data),
};

export default api;